module.exports = __webpack_public_path__ + "fonts/SeoulNamsanL.fa973893.otf";